import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'

import { Switch, Text } from '@reveni-io/reveni-ui'

import { refundMethods } from '../constants'
import { getRefundMethodName } from '../helpers'
import RefundMethodErrorsChip from '../RefundMethodErrorsChip/RefundMethodErrorsChip'
import * as Styles from './styles'

const RefundMethodHeader = ({
  refundMethod,
  savedRefundMethod,
  isEditable,
  isExpanded,
  onToggleExpanded,
  onChangeEnabled,
  errorCount,
}) => {
  const { t, i18n } = useTranslation()

  const isLocked = refundMethod.instant_allowed && savedRefundMethod.is_enabled

  const handleChangeEnabled = event => onChangeEnabled(refundMethod, event.target.checked)

  const handleToggleExpanded = () => onToggleExpanded(refundMethod.id)

  const title = (
    <Styles.RefundMethodLabel isEnabled={refundMethod.is_enabled}>
      {refundMethods[refundMethod.name].icon}
      <Text type="titleS">{getRefundMethodName(refundMethod, i18n.language, t)}</Text>
      {errorCount > 0 && <Styles.ErrorDot aria-hidden data-testid="refund-method-error-dot" />}
    </Styles.RefundMethodLabel>
  )

  return (
    <Styles.Container>
      <div>
        <Tooltip
          disabled={!isLocked}
          title={`${t(
            'Los métodos instantáneos no podrán deshabilitarse una vez habilitados. Si quieres cambiar la configuración, por favor contacta con'
          )} merchants@reveni.io`}
        >
          <Switch checked={refundMethod.is_enabled} onChange={handleChangeEnabled} disabled={!isEditable || isLocked} />
        </Tooltip>
      </div>
      <Styles.ExpandButton type="button" aria-expanded={isExpanded} onClick={handleToggleExpanded}>
        {title}
        {isExpanded ? <CaretUpIcon size={20} /> : <CaretDownIcon size={20} />}
      </Styles.ExpandButton>
      {errorCount > 0 && <RefundMethodErrorsChip count={errorCount} />}
    </Styles.Container>
  )
}

export default RefundMethodHeader
